
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

const classNames = mergeStyleSets({
    row: {
        paddingLeft: 0,
    },
});

const ListInfo = ({info}) => {
    return (
        <Stack verticalAlign="end" className={classNames.row}>
            <Text>{info}</Text>
        </Stack>
    );
}

export default ListInfo;
